import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-banner-management',
  templateUrl: './banner-management.component.html',
  styleUrls: ['./banner-management.component.scss'],
})
export class BannerManagementComponent implements OnInit {
  bannerForm: FormGroup;
  formList: any = [undefined, undefined, undefined];
  getImgeList: any = [];
  uploadedImageSrc3: string;
  elementIndexing: any;
  localImageData: any[] = [];
  imageURL: any = [];
  linkValues: any = [];
  imagesName: any = [];
  redirectionURL: any = [];

  constructor(
    public _userService: UserManagementService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.itItForm();
    this.getBannerImages();
  }

  itItForm() {
    this.bannerForm = new FormGroup({
      image: new FormControl(''),
      link: new FormControl(''),
      url: new FormControl(''),
    });
  }

  get f() {
    return this.bannerForm.controls;
  }

  // redirection url code start
  redirectUrl(event: any, index: any) {
    if (event.target.value.length > 10 && this.validURL(event.target.value)) {
      this.redirectionURL[index] = event.target.value;
      const objIndex = this.localImageData.findIndex(
        (obj) => obj.bannerId == index + 1
      );
      if (objIndex > -1) {
        this.localImageData[objIndex].url = event.target.value;
      } else {
        this.localImageData.push({
          bannerId: index + 1,
          url: event.target.value,
        });
      }
    } else {
      this.toastr.warning('Please enter valid redirection URL');
    }
  }

  // redirection url code end

  link(event: any, index: any) {
    if (
      event.target.value.length > 10 &&
      this.isValidImageUrl(event.target.value)
    ) {
      const file = document.getElementsByName('image' + index)[0];
      file['value'] = '';
      this.imageURL[index] = event.target.value;
      const objIndex = this.localImageData.findIndex(
        (obj) => obj.bannerId == index + 1
      );
      if (objIndex > -1) {
        this.localImageData[objIndex].link = event.target.value;
      } else {
        this.localImageData.push({
          bannerId: index + 1,
          name: event.target.value,
          link: event.target.value,
        });
      }
    } else {
      this.toastr.warning('Please enter valid URL');
    }
  }

  validURL(s) {
    var regexp =
      /^(ftp|http|https|chrome|:\/\/|\.|@){2,}(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\S*:\w*@)*([a-zA-Z]|(\d{1,3}|\.){7}){1,}(\w|\.{2,}|\.[a-zA-Z]{2,3}|\/|\?|&|:\d|@|=|\/|\(.*\)|#|-|%)*$/gmu;
    return regexp.test(s);
  }

  isValidImageUrl(url) {
    return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
  }
  // --------------------------setExistingImage---------------------------

  b64toBlobPromise(dataurl: string, filename: string): Promise<any> {
    return new Promise<File>((resolve, reject) => {
      if (dataurl && dataurl.length) {
        const arr = dataurl.split(',');
        const mime = /:(.*?);/.exec(arr[0])[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        resolve(new File([u8arr], filename, { type: mime }));
      } else {
        resolve(null);
      }
    });
  }

  fileToBase64(filename, filepath) {
    return new Promise((resolve) => {
      const file = new File([filename], filepath);
      const reader = new FileReader();
      // Read file content on file loaded event
      reader.onload = function (event) {
        resolve(event.target.result);
      };
      // Convert data to base64
      reader.readAsBinaryString(file);
    });
  }

  fileURL_to_blob(file_url, file) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest();
      request.open('GET', file_url, true);
      request.responseType = 'blob';
      request.onload = () => {
        var reader = new FileReader();
        reader.readAsDataURL(request.response);
        reader.onload = (e) => {
          void this.fileToBase64(file.imageName, file_url).then(
            (result: string) => {
              const fileInput = document.getElementById(
                'image' + file.bannerImageID
              );

              const linkInput = document.getElementById(
                'link' + file.bannerImageID
              );

              const redirectedURL = document.getElementById(
                'url' + file.bannerImageID
              );

              // Radio Button
              const fileRadioInput = document.getElementById(
                'imageRadio' + file.bannerImageID
              );
              const linkRadioInput = document.getElementById(
                'linkRadio' + file.bannerImageID
              );

              if (file.imageName && file.imageUrl) {
                void this.b64toBlobPromise(file_url, file.imageName).then(
                  (myFile) => {
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(myFile);
                    fileInput['files'] = dataTransfer.files;
                    fileRadioInput['checked'] = true;
                    if (fileRadioInput['checked']) {
                      linkInput['value'] = '';
                      linkInput['disabled'] = true;
                      // } else {
                      //   linkInput['disabled'] = false;
                    }
                    resolve(dataTransfer.files);
                  }
                );
              } else {
                linkInput['value'] = file.imageUrl;
                linkRadioInput['checked'] = true;
                if (linkRadioInput['checked']) {
                  fileInput['value'] = '';
                  fileInput['disabled'] = true;
                  // } else {
                  //   fileInput['disabled'] = false;
                }
              }
              redirectedURL['value'] = file.redirectUrl;
            }
          );
          resolve(e.target.result);
        };
      };
      request.onerror = function (e) {
        reject(e);
      };
      request.send();
    });
  }

  // Convert blob Url to normal URL
  blobToImage(binaryUrl) {
    if (binaryUrl) {
      var canvas = document.createElement('canvas');
      return canvas.toDataURL();
    }
  }

  sendValueOfFileInput(imdageData: any) {
    let blobUrl = this.blobToImage(imdageData.imageUrl);
    this.fileURL_to_blob(blobUrl, imdageData);
  }

  bannerCheck(id) {
    const fileInput = document.getElementById('image' + id);

    const linkInput = document.getElementById('link' + id);

    const fileRadioInput = document.getElementById('imageRadio' + id);
    const linkRadioInput = document.getElementById('linkRadio' + id);

    const imageView = document.getElementById('bannerImage' + id);

    if (fileRadioInput['checked']) {
      linkInput['value'] = '';
      imageView.removeAttribute('src');
      linkInput['disabled'] = true;
    } else {
      linkInput['disabled'] = false;
    }

    if (linkRadioInput['checked']) {
      fileInput['value'] = '';
      imageView.removeAttribute('src');
      fileInput['disabled'] = true;
    } else {
      fileInput['disabled'] = false;
    }
  }
  // ---------------------------------------------------------------------

  uploadFile(event, index) {
    // check file validation
    if (this.checkFileValidation(event.target.files[0])) {
      this.imageURL.splice(index, 1);
      const file = document.getElementsByName('image' + index)[0];
      file['value'] = '';
      this.toastr.error('Please upload correct file');
    } else {
      this.imageConverted(
        event.target.files[0],
        index,
        event.target.files[0].name
      );

      const link = document.getElementsByName('link' + index)[0];
      link['value'] = '';

      const reader = new FileReader();
      reader.onload = (e) => (this.imageURL[index] = reader.result);
      reader.readAsDataURL(event.target.files[0]);

      this.toastr.success('File added successfully');
    }
  }

  imageConverted(file: File, index, name) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let convertedImage = btoa(e.target?.result);
      let imageData = {
        bannerId: index + 1,
        name: name,
        base64String: convertedImage,
      };
      this.localImageData.push(imageData);
    };
    reader.readAsBinaryString(file);
  }

  checkFileValidation(file) {
    let imageName = file.name;
    let fileExtensionError: boolean;
    // check file type
    var allowedExtensions = [
      'jpg',
      'jpeg',
      'png',
      'JPG',
      'JPEG',
      'JFIF',
      'BMP',
      'SVG',
    ];
    let fileExtension = imageName.split('.').pop();

    if (this.isInArray(allowedExtensions, fileExtension)) {
      return false;
    } else {
      return true;
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSubmit() {
    let imageData: any = { image: [] };
    if (this.localImageData.length) {
      imageData.image = this.localImageData;
      this._userService.rotaionalBanner(imageData).subscribe((response) => {
        this.toastr.success('Uploaded Successfully.');
        this.getBannerImages();
      });
    } else {
      this.toastr.error('Please Upload the Image.');
    }
  }

  deleteBanner(id) {
    const body = {
      bannerId: id,
      isActive: true,
    };
    this._userService.removeRotationalBanner(body).subscribe((data: any) => {
      this.getBannerImages();
      this.localImageData = [];
      this.imageURL = [];
      this.linkValues = [];
      this.imagesName = [];
      this.toastr.success(data.result.message);
      this.bannerForm.reset();
    });
  }

  getBannerImages() {
    this._userService.getrotationalBanner().subscribe((response: any) => {
      this.getImgeList = response.result?.data;

      this.getImgeList.forEach((element: any) => {
        this.sendValueOfFileInput(element);
      });
      this.checklength();
    });
  }

  checklength() {
    if (this.formList[0] == undefined) {
      this.formList[0] = this.getImgeList.filter(
        (x) => x.bannerImageID === 1
      )[0]?.imageUrl;
    } else {
      this.formList[0] = this.getImgeList.filter(
        (x) => x.bannerImageID === 1
      )[0]?.imageUrl;
    }
    // ------------
    if (this.formList[1] == undefined) {
      this.formList[1] = this.getImgeList.filter(
        (x) => x.bannerImageID === 2
      )[0]?.imageUrl;
    } else {
      this.formList[1] = this.getImgeList.filter(
        (x) => x.bannerImageID === 2
      )[0]?.imageUrl;
    }
    // ------------
    if (this.formList[2] == undefined) {
      this.formList[2] = this.getImgeList.filter(
        (x) => x.bannerImageID === 3
      )[0]?.imageUrl;
    } else {
      this.formList[2] = this.getImgeList.filter(
        (x) => x.bannerImageID === 3
      )[0]?.imageUrl;
    }
  }

  imagePreview() {
    this.getImgeList.forEach((file) => {
      const imageView = document.getElementById(
        'bannerImage' + file.bannerImageID
      );
      imageView.setAttribute('src', file.imageUrl);
    });
  }

  refreshForm() {
    this.bannerForm.reset();
    this.getBannerImages();
    this.imagePreview();
    this.localImageData = [];
    this.imageURL = [];
    this.linkValues = [];
    this.imagesName = [];
  }
}
